<template>
    <section class="theme-list wrapper" ref="wrapper" >
        <!-- <h1 class="evaluate-title">我得说两句</h1> -->
        <ul class="tab-wrap">
            <li
                :class="activeTab === item.key ? 'tab-wrap__item active' : 'tab-wrap__item'"
                v-for="item in tabList"
                :key="item.key"
                @click="handleTabClick(item.key)"
            >
                {{item.text}}
            </li>
        </ul>
        <div v-if="activeTab === '0'">
            <template v-if="hotCommentsList.length>0">
                <div class="comments-title ">
                    <img :src="hotImg" class="icon_hot"/>
                    热门留言
                    </div>
                <ul>
                    <li :key="index" v-for="(item, index) in hotCommentsList" >
                        <header class="flex flex-cross-center flex-main-justify">
                            <div class="flex flex-cross-center">
                                <div class="avatar" :style="{backgroundImage:`url(${item.userIcon?item.userIcon:icon})`}"></div>
                                <div class="info-area">
                                    <div class="name ellipsis">{{item.username}}</div>
                                    <div class="time ellipsis">{{getDate(item.date) | dateCompared}}</div>
                                </div>
                            </div>
                            <div class="like flex flex-cross-center">
                                <span :class="[item.isLike?'active-num':'num']">{{getLikesCount(item.likes+'')}}</span>
                                 <i :class="[item.isLike?'active-good':'good']"></i>
                            </div>
                        </header>
                        <!-- <section>
                            <p v-html="item.content"></p>
                        </section> -->
                        <section>
                           <themeRemark :content="item.content" :image="item.image"></themeRemark>
                        </section>
                        <div class="origin" v-if="item.parent">
                            <div class="origin-info flex flex-cross-center flex-main-justify">
                                <div class="origin-name">{{item.parent.username}}</div>
                                <div class="origin-time">{{getDate(item.parent.date)| dateCompared}}</div>
                            </div>
                            <div class="origin-content">
                                {{item.parent.content}}
                            </div>
                            <div class="replyImage" v-if="!!item.parent.image">
                                <img :src="item.parent.image" alt="" >
                            </div>
                        </div>
                    </li>
                    <!-- <li class="flex" v-for="item in hotCommentsList" :key="item.id">
                        <div class="avatar" :style="{backgroundImage:`url(${item.userIcon?item.userIcon:head})`}"></div>
                        <div class="bubble">
                            <div class="flex-default info">
                                <span>{{item.username}}</span>
                                <div class="like flex flex-cross-center" @click.stop="setActiveLike(item)">
                                    <i :class="[item.isLike?'active-good':'good']"></i>
                                    <span :class="[item.isLike?'active-num':'num']">{{getLikesCount(item.likes+'')}}</span>
                                </div>
                            </div>
                            <time>{{getDate(item.date) | dateCompared}}</time>
                           
                            <themeRemark :content="item.content" :image="item.image"></themeRemark>

                            <div class="reply" v-if="item.parent" >
                                <span>回复：</span><span>{{item.parent.username}}</span>
                                <p class="replyContent">{{item.parent.content}}</p>
                                <div class="replyImage" v-if="!!item.parent.image">
                                    <img :src="item.parent.image" alt="" >
                                </div>
                            </div>
                        </div>
                    </li> -->
                </ul>
            </template>
            <template v-if="newCommentsList.length>0">
                <div class="comments-title ">
                    <img :src="hotImg" class="icon_liuyan"/>最新留言</div>
                <ul  v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="50" >
                    <li :key="index" v-for="(item, index) in newCommentsList" >
                        <header class="flex flex-cross-center flex-main-justify">
                            <div class="flex flex-cross-center">
                                <div class="avatar" :style="{backgroundImage:`url(${item.userIcon?item.userIcon:icon})`}"></div>
                                <div class="info-area">
                                    <div class="name ellipsis">{{item.username}}</div>
                                    <div class="time ellipsis">{{getDate(item.date) | dateCompared}}</div>
                                </div>
                            </div>
                            <div class="like flex flex-cross-center">
                                <span :class="[item.isLike?'active-num':'num']">{{getLikesCount(item.likes+'')}}</span>
                                <i :class="[item.isLike?'active-good':'good']"></i>
                            </div>
                        </header>
                        <!-- <section>
                            <p v-html="item.content"></p>
                        </section> -->
                        <section>
                           <themeRemark :content="item.content" :image="item.image"></themeRemark>
                        </section>
                        <div class="origin" v-if="item.parent">
                            <div class="origin-info flex flex-cross-center flex-main-justify">
                                <div class="origin-name">{{item.parent.username}}</div>
                                <div class="origin-time">{{getDate(item.parent.date)| dateCompared}}</div>
                            </div>
                            <div class="origin-content">
                                {{item.parent.content}}
                            </div>
                            <div class="replyImage" v-if="!!item.parent.image">
                                <img :src="item.parent.image" alt="" >
                            </div>
                        </div>
                    </li>
                    <!-- <li class="flex" v-for="item in newCommentsList" :key="item.id">
                        <div class="avatar" :style="{backgroundImage:`url(${item.userIcon?item.userIcon:head})`}"></div>
                        <div class="bubble">
                            <div class="flex-default info">
                                <span>{{item.username}}</span>
                                <div class="like flex flex-cross-center" @click.stop="setActiveLike(item)">
                                    <i :class="[item.isLike?'active-good':'good']"></i>
                                    <span :class="[item.isLike?'active-num':'num']">{{getLikesCount(item.likes+'')}}</span>
                                </div>
                            </div>
                            <time>{{getDate(item.date) | dateCompared}}</time>
                            <themeRemark :content="item.content" :image="item.image"></themeRemark>
                            <div class="reply" v-if="item.parent" >
                                <span>回复：</span><span>{{item.parent.username}}</span>
                                <p class="replyContent">{{item.parent.content}}</p>
                                <div class="replyImage" v-if="!!item.parent.image">
                                    <img :src="item.parent.image" alt="" >
                                </div>
                            </div>
                        </div>
                    </li> -->
                </ul>    
            </template>
            <div v-else class="null-data">暂无相关内容</div>
            <p v-if="loading" class="loading">
                <spinner type="fading-circle"></spinner>
                加载中...
            </p>
            <p v-if="isAll" class="loading">已显示全部内容</p>
        </div>
        <template  v-if="activeTab === '1'">
            <listArticle></listArticle>
        </template>
    </section>
</template>
<script>
import api from "src/constants/appapi";
import head from 'src/images/mine_avatar.png'
import icon from 'src/images/icon_user_default_avatar.png'
import hotImg from 'src/images/icon_Quotes@2x.png'
import moment from 'moment'
import { Toast,Spinner,InfiniteScroll } from "mint-ui";
import { intfc_prefix_common } from 'constants/project'
import listArticle from "./theme-list-article";
import themeRemark from './theme-remark';

export default {
    directives: { InfiniteScroll },
    components: {
      spinner: Spinner,
      listArticle,
      themeRemark,
    },
    props:['sysCode'],
    data(){
        return {
            activeTab: '0',
            tabList: [
                { 
                    key: '0',
                    text: '留言',
                },
                { 
                    key: '1',
                    text: '相关阅读',
                }
            ],
            head,
            icon,
            hotImg,
            loading: false,
            isAll: false,
            wrapperHeight: 0,
            hotCommentsList:[],
            newCommentsList:[],
            data:{
                page: {
                    last: 2
                }
            },
            next: 1,
            pageToken:''
        }
    },
    created(){
        // this.getComment(this.$route.params.id)
        window.appapi = api;
        this.isSharePage = appapi.isSharePage();
    },
    mounted() {
        this.hasNoListArticle()
        this.$nextTick(() => {
            this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top
        })
    },
    watch:{
        'sysCode' (newVal, oldVal) {
            console.log(newVal, 'newVal, oldVal', oldVal)
            if(newVal){
                this.getComment(this.$route.params.id)
            }
        },
    },
    methods: {
        hasNoListArticle(){
            this.$axios.get(`${intfc_prefix_common}/api/v2/articles/recommentPage?articleId=${this.$route.params.id}&pageToken=${this.pageToken}&size=5`)
                .then(res=> {
                    const result = res
                    if (res.code === 0 && res.item.count == 0) {
                        this.tabList.splice(1)
                    }
                })
            
        },
        handleTabClick(value) {
            this.activeTab = value;
        },
        getComment (articleId) {
            this.loading = true
            this.pageToken = this.next * 1
            const pageLast = this.data.page.last * 1
            if ( this.pageToken > pageLast) {
                this.loading = false
                this.isAll = true
                return false
            }
            // ${this.sysCode}
            this.$axios.get(`${intfc_prefix_common}/api/comments/commentList/${this.sysCode}/${this.$route.params.id}?pageToken=${this.pageToken}`)
                .then(res=> {
                    const result = res
                    if (res.code === 0) {
                        this.data = result
                        this.loading = false
                        if (this.data.item && this.data.item.hotComments &&this.data.item.hotComments.length > 0 && this.next === 1){
                            this.hotCommentsList = this.data.item.hotComments
                        }
                        if (this.data.item && this.data.item.newComments && this.data.item.newComments.length > 0) {
                            // this.data.items.map((item) => {
                            //     this.list.push(item)
                            // })
                            this.newCommentsList.push(...this.data.item.newComments)
                            this.next++
                        }
                    } else {
                        Toast(res.msg)
                        this.loading = false
                    }
                })
        },
        getDate:(date)=>{
            // return moment(date).format('HH:mm')
            return date.slice(0, -2) + ':00'
        },
        loadMore() {
            // console.log(this.isAll,'isAll',this.loading,'this.loading')
            if (this.isAll || this.loading) return false
            this.getComment(this.$route.params.id)
        },

        appPostMessage (name, value='') {
            // 调用app原生方法
            if (name) window.appapi.appPostMessage(name, value)
        },

        // getTime (time) {
        //     let result = ''
        //     if (time) {
        //         result = time.substring(0,10) + ' ' + time.substring(11,16)
        //     }
        //     return result
        // },

        getLikesCount (count) {
            let result = ''
            if (count > 0) {
                result = count
                if (count > 999999) {
                    result = count.substring(0,count.length - 4) + '万'
                    if (count > 99999999) {
                        result = '过亿'
                    }
                }
            }
            return result
        },

        setActiveLike (opt) {
			    this.$emit("on-openApp", opt);

            // if (this.isSharePage || !opt.id) return
            // this.$forceUpdate();
            // if (!opt.isLike) {
            //     this.appPostMessage('phraise',JSON.stringify(opt))
            //     this.comments.map((option) => {
            //         if (opt.id === option.id) {
            //             option.isLike = true
            //             option.likes += 1
            //         }
            //     })
            // }
        },

    },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import "~src/stylus/mixin";
	@import '~src/stylus/page-themeList.styl';
    .theme-list
        .tab-wrap
            padding 0 30px;
            margin-bottom: 0px;
            width: 100%;
            // height: 79px;
            box-sizing border-box
            // border-bottom: 1px solid rgba(0, 0, 0, .1);
            // display: flex;
            // flex-direction: row;
            // justify-content: space-around;
            // align-items: center;
            &__item
                display: inline-block;
                color: #666;
                font-size:32px;
                font-weight: 400;
                line-height: 88px;
                height: 79px;
                margin-right 32px;
                &.active
                    position relative
                    color: #222;
                    font-weight: 500;
                    border-bottom: 4px solid #D4282B;
                    // &:after
                    //     content ''
                    //     position absolute
                    //     bottom 0
                    //     left 50%
                    //     margin-left -18px
                    //     width: 36px;
                    //     height: 4px;
                    //     background: #d6303f;
                    //     border-radius: 2px;
</style>


// WEBPACK FOOTER //
// theme-list.vue?f8f4fa1a